import { useRegion } from "hooks";
import { useUser } from "lib/user";
import { useEffect, useState } from "react";
import { getInitialAnonId } from "lib/apollo/initialvals";

export const useZendeskTracking = (url: string): string => {
  const [canTrack, setCanTrack] = useState(false);
  const region = useRegion();
  const user = useUser();
  const segmentAnonId = getInitialAnonId();

  useEffect(() => {
    if (!url.startsWith("https://beautypiehelp") || !segmentAnonId)
      return () => undefined;

    if (region !== "uk") {
      setCanTrack(true);
    } else {
      const onOneTrustGroupsUpdated = () => {
        if (window.OnetrustActiveGroups?.includes("C0002")) setCanTrack(true);
      };

      window.addEventListener("OneTrustGroupsUpdated", onOneTrustGroupsUpdated);
      onOneTrustGroupsUpdated();

      return () => {
        window.removeEventListener(
          "OneTrustGroupsUpdated",
          onOneTrustGroupsUpdated
        );
      };
    }
  }, [segmentAnonId, region, url]);

  if (!canTrack) return url;

  const isProd =
    typeof window !== "undefined" &&
    window.location.hostname === "www.beautypie.com";

  const query = `bp-anon-id=${segmentAnonId}&env=${
    isProd ? "prod" : "preview"
  }${user?.isLoggedIn ? `&bp-user-id=${user?.id}` : ""}`;

  return `${url}${url.includes("?") ? "&" : "?"}${query}`;
};
